import { State } from '@app/store/state';

export const selectAnalyticsRecordingInfo = (state: State) =>
  state.analytics.recordingInfo;

export const selectAnalyticsSeriesInfo = (state: State) =>
  state.analytics.seriesInfo;
